'use client';

import { Skeleton } from '@packages/shared/src/ui/Skeleton/Skeleton';
import { Carousel } from '@packages/modules/src/Carousel/Carousel';
import { ComponentTypes } from '../../../interfaces/components';
import { registerComponents } from '../ComponentRecognizer/componentRegistry';
import { RelatedContentItem } from './RelatedContentItem';
import type { RelatedContentType } from './types';
import { useRelatedContentGql } from './useRelatedContentGql';

export const RelatedContent = ({
  data: {
    field_number_of_hits: limit,
    taxonomy_term,
    behavior_paragraph_background_color: backgroundColor,
    behavior_paragraph_outer_spacing: margin,
  },
  className,
}: {
  data: RelatedContentType;
  className?: string;
}) => {
  const { fetching, relatedContentData, error } = useRelatedContentGql(
    taxonomy_term[0].name,
    limit,
  );
  if (error) {
    return null;
  }

  return (
    // className contains possible width type by behavior_paragraph_widthtype
    // - it must be applied to a wrapper div to not interfere with Carousel inner styles
    <div className={className}>
      <Carousel style={{ backgroundColor, ...(margin && { margin }) }}>
        {fetching &&
          Array.from({ length: limit }).map((_, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <Skeleton key={index} className="h-[23rem]" aria-label="loading" />
          ))}
        {relatedContentData
          .filter((item) => !!item)
          .map((item) => (
            <RelatedContentItem key={item.id} {...item} />
          ))}
      </Carousel>
    </div>
  );
};

// Needed to run this component in Storybook and Jest tests. Register the component in a global componentRegistry object
registerComponents({
  [ComponentTypes.RelatedContent]: RelatedContent,
});
